import React from "react";

import CollapsibleMenu from "src/components/common/CollapsibleMenu";
import Dropdown from "src/components/common/Dropdown";
import { HUMANIZED_OBJECTIVES } from "src/redux/Tx/constants";

import styles from "./styles.module.scss";

export default ({ apply, value }) => {
    const OBJECTIVE_OPTIONS = Object.entries(HUMANIZED_OBJECTIVES).reduce(
        (options, e) => [...options, { label: e[1], value: e[0] }],
        [{ label: "--", value: "" }]
    );

    return (
        <CollapsibleMenu
            title="Objective"
            dataTestId="tx-offer-objective"
            allowsOverflow
        >
            <div className={styles.objective}>
                <Dropdown
                    mainStyle="thick-black"
                    value={
                        OBJECTIVE_OPTIONS.find((e) => e.value === value) || null
                    }
                    options={OBJECTIVE_OPTIONS}
                    placeholder="Select"
                    onChange={(e) => apply(e.value)}
                    dataTestId="tx-offer-select-objective"
                    ariaLabel="Select Trade objective"
                />
            </div>
        </CollapsibleMenu>
    );
};
